var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.cssClass,attrs:{"href":"https://motka.design","target":"_blank"},domProps:{"textContent":_vm._s(_vm.designByText)}})}
var staticRenderFns = []

export { render, staticRenderFns }